$(document).ready(function () {
    // Add class exclude to make sure, that only the current form will be validated
    $(".form-control").addClass("excluded");
    $("[type=checkbox]").addClass("excluded");

    $("form")
        .formValidation({
            framework: "bootstrap",
            excluded: [":disabled", ".excluded", ":hidden", ":not(:visible)"],
            live: "submitted",
            autoFocus: false
        })
    .on("err.field.fv", function (e, data) {
        data.fv.disableSubmitButtons(false);
    })
    .on("success.field.fv", function (e, data) {
        data.fv.disableSubmitButtons(false);
    })
    .on("status.field.fv", function (e, data) {
        data.fv.disableSubmitButtons(false);
    })
    .on("success.form.fv", function (e) {
        e.preventDefault();
        var $form = $(e.target);
        // Make sure that select control will be validated properly
        $("select.form-control:not(.excluded)").each(function (index) {
            var value = $(this).val();
            if (value.length > 0) {
                $(this).find("option").removeAttr("selected");
                $(this).find("option[value='" + value + "']").attr("selected", "selected");
                $(this).val(value);
            }
        });
        var $button = $form.data("formValidation").getSubmitButton();
        // Disable button and show loading animation after submit
        $button.prop("disabled", true);
        $button.find(".btn-load.fa-spin").css("visibility", "visible");
        var $formContainer = $button.closest(".form-container");
        var action = $button.attr("data-action");

        // Add form tags arrounf current form container to only serialize data within container
        var clone = $formContainer.clone().wrap("<form />").parent();
        var formData = clone.serializeObject();
        FormSubmit(JSON.stringify(formData), action, $button);
    });

    //bindSelect();

    //$("[data-date-picker]").datetimepicker({
    //    format: "DD/MM/YYYY"
    //});

    $("#AcceptedTermsCheck").on("click",
        function () {            
            $("#AcceptedTerms").val($(this).is(":checked"));
            var group = $(this).closest(".form-group");
            var err = group.find(".help-block");
            if (!$(this).is(":checked")) {
                err.show();
                group.addClass("has-error");
            } else {
                err.hide();
                group.removeClass("has-error");
            }
        });
    $("#ContactByEntGroupCheck").on("click",
        function () {
            $("#ContactByEntGroup").val($(this).is(":checked"));
        });
});

$(window).load(function () {
    if ($(".form-control.phone").length > 0) {
        $(".form-control.phone")
            .intlTelInput({
                utilsScript:
                    "/WWW_Shared/Assets/js/libphonenumber.js",
                autoPlaceholder: false,
                defaultCountry: "au"
            });
    }
});

function validateContainer(id) {
    var $container = $(id);
    $(".form-control").addClass("excluded");
    $("[type=checkbox]").addClass("excluded");
    $container.find(".excluded").removeClass("excluded");

    var fv = $("form").data("formValidation");
    var isValidStep = false;
    if (typeof fv !== "undefined" && fv !== null) {
        fv.validateContainer($container);
        isValidStep = fv.isValidContainer($container);
    }
    var selectsValid = selectValidation();
    if (isValidStep) {
        isValidStep = selectsValid;
    }
    if (isValidStep === false || isValidStep === null) {
        $(".has-error").find(".form-control:not(.excluded), .has-error [type=checkbox]:not(.excluded)")[0].focus();
        return false;
    }
    return true;
}

function selectValidation() {
    var valid = true;
    $("select[required]").each(
        function () {
            var parent = $(this).closest(".form-group");

            $(this).on("change",
                function() {
                    if ($(this).val() !== "") {
                        parent.removeClass("has-error");
                        parent.find(".help-block").remove();
                    }
                });

            if ($(this).val() === "") {
                var err = $(this).data("fv-notempty-message");
                parent.addClass("has-error");                
                if (parent.has(".help-block").size() === 0) {
                    parent.append("<small class='help-block'>" + err + "</small>");
                } else {
                    parent.find(".help-block").show();
                }
                valid = false;
            }
        });
    return valid;
}

function FormSubmit(formData, action, btn) {
    console.log(formData);
    $.ajax({
        url: action,
        type: "POST",
        data: formData,
        contentType: "application/json",
        success: function (data) { OnFormSubmitSuccess(data, btn); },
        error: function (xhr, status) { OnFormSubmitError(xhr.responseText, btn); }
    });
    return false;
}

function OnFormSubmitSuccess(result, btn) {
    console.log("success");
    console.log(result);
    var $button = btn;
    var $form = $button.closest(".form-container");
    var $danger = $form.find(".alert-danger");
    var $success = $form.find(".alert-success");

    $(".has-error").removeClass("has-error");
    $(".help-block").hide();

    if (result.Info != null && result.Info.Errors.length > 0) {
        $button.prop("disabled", false);
        $button.removeClass("disabled");
        $button.find(".btn-load.fa-spin").css("visibility", "hidden");

        for (var i = 0, len = result.Info.Errors.length; i < len; i++) {
            var inp = $("[name=" + result.Info.Errors[i].ItemRef + "]");
            if (inp != null) {
                var parent = inp.closest(".form-group");
                parent.addClass("has-error");
                if (parent.has(".help-block").size() === 0) {
                    parent.append("<small class='help-block'>" + result.Info.Errors[i].Message + "</small>");
                } else {
                    parent.find(".help-block").show();
                }
            }

            $("[data-message]", $danger).hide();
            var err = $danger.find("[data-message='" + result.Info.Errors[i].ErrorCode + "']");
            if (err !== null && err !== undefined) {
                err.show();

                if (err.is("[data-popup]")) {
                    
                    $(".info-modal .modal-body").html(err.parent().clone().show());
                    
                    $(".info-modal").modal();
                }

            } else {
                $danger.append("<p>" + result.Info.Errors[i].Message + "</p>");
            }
            $form.find(".alert-danger").show();
            if ($form.find(".alert-danger").children(':visible').length <= 0) {
                $form.find(".alert-danger").hide();
            }
        }
        $form.find(".alert-success").hide();
        var onError = $button.data("on-error");
        if (onError != null && onError !== "") {
            Function("result", onError)(result);
        }

    } else {
        if (result.Info != null && result.Info.Infos.length > 0) {
            for (var j = 0, len2 = result.Info.Infos.length; j < len2; j++) {
                var inf = $success.find("[data-message='" + result.Info.Infos[j].InfoCode + "']");
                if (inf !== null && inf !== undefined && inf.length > 0) {
                    inf.show();
                } else {
                    $success.append("<p>" + result.Info.Infos[j].Message + "</p>");
                }
            }            
        }
        var onSuccess = $button.data("on-success");
        if (onSuccess != null && onSuccess !== "") {
            Function(onSuccess)();
        }
        $success.show();
        $form.find(".alert-danger").hide();

        var ret = $button.attr("data-return");
        if (ret === "collectdetails") {
            if (result.Data.ContactDetailsUpdatedDate === null || (!result.Data.AcceptedTerms && result.Data.AcceptTermsRequired)) {
                window.location.href = "/login/my-details";
                return;
            } else {
                ret = "referrer";
            }
        }

        if (ret === "referrer") {
            var returnUrl = $.url().param("returnUrl");
            var loginPath = $("body").data("login-path");
            if (returnUrl !== null && returnUrl !== undefined && returnUrl !== "" && returnUrl !== loginPath) {
                window.location.href = returnUrl;
            } else {
                window.location.href = "/";
            }
        }
        else if (ret !== null && ret !== undefined && ret !== "") {
            window.location.href = ret;
        } else {
            $button.prop("disabled", false);
            $button.find(".btn-load.fa-spin").css("visibility", "hidden");
            $button.removeClass("disabled");
        }
    }
}

function OnFormSubmitError(result, btn) {
    console.log("error");
    console.log(result);
    var $button = btn;
    var $form = $button.closest(".form-container");
    $button.prop("disabled", false);
    $button.find(".btn-load.fa-spin").css("visibility", "hidden");
    if (result && result.length > 0) {
        $(id).find("[data-error]").show().text(result);
    }
    $form.find(".alert-success").hide();
    $form.find(".alert-danger").show();
    $form.find(["data-error"]).hide();
}

function bindSelect() {
    $("select[data-default]").each(function (index) {
        var value = $(this).attr("data-default");
        if (value && value.length > 0) {
            $(this).find("option").removeAttr("selected");
            $(this).find("option[value='" + value + "']").attr("selected", "selected");
            $(this).val(value);
        }
    });
}

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || "");
        } else {
            o[this.name] = this.value || "";
        }
    });
    return o;
};

// Submit form on clicking enter in text control
$(".form-container input[type=text], .form-container input[type=email], .form-container input[type=password], .form-container input[type=number], .form-container textarea").keypress(function (a) {
    if (a.keyCode === 13 || (a.keyCode === 10 && a.ctrlKey)) {
        if (!$(this).hasClass("no-enter-submit") || a.ctrlKey) {
            (a.preventDefault(), $(this).parents(".form-container").find("[type=submit]:visible").click());
        }
    }
});

function hideFieldsOnSubmitted() {
    $(".form-group").hide();
}

function singleLoginSuccess(result) {
    if (result.Info !== null && result.Info.Errors.length > 0) {
        if (result.Info.Errors[0].ErrorCode === "USERHASPASSWORD") {
            $(".pnl_password").show();
            $(".form-group-submit button").attr("data-action", "/api/fvmember/login");
            $(".form-group-submit button")
                .attr("data-return", $(".form-group-submit button").attr("data-return-login"));
        }
    }
}

$(document).on("change", "select", function () {
    $('option[value="' + this.value + '"]', this)
        .prop("selected", true).siblings() 
        .removeAttr("selected");
});